import { createSlice } from "@reduxjs/toolkit";

const getStoredMode = () => {
  if (typeof window === "undefined") return "light";
  const stored = window.localStorage.getItem("mode");
  return stored === "light" || stored === "dark" ? stored : "light";
};

const initialState = {
  mode: getStoredMode(),
  userId: "63701cc1f03239c72c000181",
};

export const globalSlide = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
      if (typeof window !== "undefined") {
        window.localStorage.setItem("mode", state.mode);
      }
    }
  }
});

export const { setMode } = globalSlide.actions;

export default globalSlide.reducer;